import PlaceType from '../types/Place';

import request from './request';

export const fetchPlace = (lang: string) => {
	return request.get<PlaceType>(`/place?lang=${lang}`);
};
